import { memo } from 'react';
import { Center } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';

const ChevronIcon = ({ src = null, imageProps = null, ...props }) => (
  <Center
    borderRadius="full"
    boxSizing="border-box"
    bgColor="white"
    overflow="hidden"
    boxSize={{ laptop: '72px', tablet: '36px', mobile: '' }}
    {...props}
  >
    <NextImage src={src} objectFit="contain" alt="chevron_icon" {...imageProps} />
  </Center>
);

export default memo(ChevronIcon);
